import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Products from "./pages/Products";
import Request from "./pages/Request";
import { Toaster } from "./components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/szolgaltatasok"
                            element={<Services />}
                        />
                        <Route path="/termekek" element={<Products />} />
                        <Route path="/ajanlatkeres" element={<Request />} />
                        {/* Régi /rolunk hivatkozás: irányítsa a főoldal Rólunk szakaszára */}
                        <Route
                            path="/rolunk"
                            element={<Navigate to="/#rolunk" replace />}
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster position="bottom-right" />
        </div>
    );
}

export default App;
